<template>
  <DatatableReportV3
    v-if="tenantLoaded"
    id="jobs-table"
    title="Appointments"
    download-url="/reports/appointments"
    :config="config"
    :source="source"
    :filters="filters"
  >
    <template #column-actions="{ columnValue }">
      <AppointmentActions
        :appointment="parseJSON(columnValue).appointment"
        :customer="parseJSON(columnValue).customer"
        view-on-schedule
        @save-success="refreshDatatable"
      />
    </template>
  </DatatableReportV3>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { customerClassificationColumns } from "@/lib/customerTypes";
import { EventBus } from "@/lib/event_bus";

import AppointmentActions from "@/Job/AppointmentActions.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";

export default {
  components: {
    DatatableReportV3,
    AppointmentActions
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState({
      tenantLoaded({ tenant }) {
        return !!tenant;
      }
    }),
    ...mapGetters(["jobStatusEnabled"]),
    config() {
      return {
        responsive: true,
        order: [[1, "desc"]],
        columns: [
          { data: "appointment", responsivePriority: 2 },
          {
            data: "when",
            title: "Scheduled For",
            filterName: "scheduled_time",
            responsivePriority: 3
          },
          { data: "created_at", title: "Created At", responsivePriority: 16 },
          {
            data: "created_by_source",
            title: "Created Source",
            orderable: false,
            searchable: false,
            responsivePriority: 18
          },
          {
            data: "created_by",
            title: "Created By",
            filterName: "created_by_staff_gid",
            orderable: false,
            searchable: false,
            responsivePriority: 17
          },
          { data: "job", responsivePriority: 8 },
          {
            data: "tags",
            title: "Tags",
            orderable: false,
            searchable: false,
            responsivePriority: 15
          },
          {
            data: "job_status",
            title: "Job Status",
            filterName: "job_status_id",
            orderable: false,
            visible: this.jobStatusEnabled,
            responsivePriority: 11
          },
          ...customerClassificationColumns(),
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 14 },
          { data: "customer_phone", title: "Phone", responsivePriority: 7 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 13
          },
          { data: "address", orderable: false, responsivePriority: 6 },
          {
            data: "status",
            title: "Appt Status",
            searchable: false,
            responsivePriority: 4
          },
          {
            data: "technician",
            title: "Technician(s)",
            filterName: "technician_id",
            responsivePriority: 5
          },
          {
            data: "department",
            filterName: "department_id",
            responsivePriority: 10
          },
          {
            data: "task_type",
            title: "Service Category",
            filterName: "service_category",
            responsivePriority: 9
          },
          { data: "revenue", searchable: false, responsivePriority: 12 },
          {
            data: "actions",
            title: "",
            searchable: false,
            orderable: false
          }
        ],
        vueComponents: [
          {
            rootId: "tag-list-vue",
            component: TagList
          }
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Appointments" });
  },
  methods: {
    ...mapActions(["addBreadcrumb"]),
    parseJSON(jsonStr) {
      try {
        return JSON.parse(jsonStr.replace(/&quot;/g, '"'));
      } catch (e) {
        return { appointment: null, customer: null };
      }
    },
    refreshDatatable() {
      EventBus.$emit("refresh-datatable");
    }
  }
};
</script>

<style lang="scss">
.pinned-icon {
  color: white;
  margin-right: 0.2rem;
  text-shadow: 0 0 6px rgba(34, 34, 34, 0.8);
}
</style>
